import { render, staticRenderFns } from "./creditStatisticsList.vue?vue&type=template&id=75273342&scoped=true"
import script from "./creditStatisticsList.vue?vue&type=script&lang=js"
export * from "./creditStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./creditStatisticsList.vue?vue&type=style&index=0&id=75273342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75273342",
  null
  
)

export default component.exports